import { useState } from 'react';
import { Box, Switch, Typography } from '@mui/material';
import type { MyDetailsDto } from '@/api/dashboardApi';
import { Section, SectionCard, SectionHeader } from '@/components/common';

const RATING_VISIBILITY_KEY = 'myDetails.ratingVisible';

interface MyDetailsSectionProps {
  myDetails: MyDetailsDto;
}

export function MyDetailsSection({ myDetails }: MyDetailsSectionProps) {
  const [ratingVisible, setRatingVisible] = useState(() => {
    const stored = localStorage.getItem(RATING_VISIBILITY_KEY);
    return stored === null ? true : stored === 'true';
  });

  const displayRating =
    ratingVisible && myDetails.lastAppraisalRating
      ? myDetails.lastAppraisalRating
      : '-';

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    setRatingVisible(newValue);
    localStorage.setItem(RATING_VISIBILITY_KEY, String(newValue));
  };

  return (
    <Section>
      <SectionHeader
        action={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body1">Rating Visibility</Typography>
            <Switch
              checked={ratingVisible}
              onChange={handleToggle}
              size="small"
            />
          </Box>
        }
      >
        MY DETAILS
      </SectionHeader>
      <SectionCard>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, flexWrap: 'wrap', justifyContent: 'space-between', gap: { xs: 2, md: 3 } }}>
          <DetailItem label="OC&Cer:" value={myDetails.name} />
          <DetailItem label="Billing Grade:" value={myDetails.billingGrade ?? '-'} />
          <DetailItem label="Tenure in Grade:" value={myDetails.tenureInGrade ?? '-'} />
          <DetailItem label="Last Appraisal Rating:" value={displayRating} />
          <DetailItem
            label="Staffing Weeks:"
            value={myDetails.staffingWeeks != null && myDetails.staffingWeeks > 0 ? `${myDetails.staffingWeeks} weeks` : '-'}
          />
        </Box>
      </SectionCard>
    </Section>
  );
}

function DetailItem({ label, value }: { label: string; value: string }) {
  return (
    <Box sx={{ minWidth: 120 }}>
      <Typography variant="body1" color="text.secondary" display="block">
        {label}
      </Typography>
      <Typography variant="body1">{value}</Typography>
    </Box>
  );
}

export default MyDetailsSection;
